import { css } from '@emotion/css';
import React from 'react';
import { pulse } from '../shared/keyframe-animations';

export const OnlinePulse: React.FC<{ on?: boolean }> = ({ on }) => {
  return (
    <svg
      className={
        on
          ? css`
              path {
                animation: ${pulse} 1.55s linear infinite;
                &:nth-child(1) {
                  animation-delay: 0.4s;
                }
                &:nth-child(3) {
                  animation: none;
                }
              }
            `
          : ''
      }
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 1.09123C0 1.69194 0.490521 2.18246 1.09123 2.18246C5.90047 2.18246 9.81754 6.09597 9.81754 10.9088C9.81754 11.5095 10.3045 12 10.9088 12C11.5095 12 12 11.5095 12 10.9088C11.9964 4.891 7.10545 0 1.09123 0C0.490521 0 0 0.486967 0 1.09123Z"
        fill="#B8F0C0"
      />
      <path
        d="M0 4.90886C0 5.50957 0.490521 6.00009 1.09123 6.00009C3.79621 6.00009 6 8.20033 6 10.9089C6 11.5096 6.49052 12.0001 7.09123 12.0001C7.69194 12.0001 8.18247 11.5096 8.18247 10.9089C8.18247 6.99891 5.00119 3.81763 1.09479 3.81763C0.490521 3.81763 0 4.30459 0 4.90886Z"
        fill="#B8F0C0"
      />
      <path
        d="M1.69133 11.7264C2.47657 11.7264 3.11313 11.0899 3.11313 10.3046C3.11313 9.51937 2.47657 8.88281 1.69133 8.88281C0.906093 8.88281 0.269531 9.51937 0.269531 10.3046C0.269531 11.0899 0.906093 11.7264 1.69133 11.7264Z"
        fill="#B8F0C0"
      />
    </svg>
  );
};
